import completeQuickCreation from 'actions/salon/completeQuickCreation.action';
import postQuickSalonData from 'actions/salon/postQuickSalonData.action';
import postSalonData from 'actions/salon/postSalonData.action';
import SEGMENT from 'config/segment.singleton';
import QST from 'constants/quickSetupType.const';
import getAnyOrVoid from 'utils/accessors/getAnyOrVoid.util';
import { selectCognitoAttributeSub } from 'utils/cognito.util';
import getState from 'utils/core/getState.util';
import refreshTokens from 'utils/core/refreshTokens.util';
import withOptions from 'utils/functions/withOptions.util';
import logger from 'utils/logger.util';

const L = logger('postSalonDataAndRefreshTokens');

const postSalonDataAndRefreshTokens = L.wrap(
  '()',
  withOptions(({ data, type, quick }) => async (dispatch) => {
    try {
      const salonResult = quick ? await dispatch(postQuickSalonData({ data, type: type || QST.hair })) : await dispatch(postSalonData(data));

      const username = selectCognitoAttributeSub(getState());
      const salonId = getAnyOrVoid('response.id', salonResult);
      const companyName = getAnyOrVoid('response.name', salonResult);

      await refreshTokens({ salonId, companyName, force: true });

      // Require BOTH id and name: an id-only call would create a nameless ("Unknown")
      // company in Intercom, matching the unattached-users symptom we just fixed.
      if (salonId && companyName) {
        L.debug('()', { username, salonId, companyName });

        // username is the Cognito sub, matching the userId used by SEGMENT.identify.
        // createdAt = now (Unix seconds): this thunk runs immediately after the salon
        // POST returns, so it's the correct moment for Intercom's Company created at.
        const createdAt = Math.floor(Date.now() / 1000);
        SEGMENT.setCompany({ username, id: salonId, name: companyName, createdAt });
      }

      if (quick) {
        await dispatch(completeQuickCreation());
      }

      return salonResult;
    } catch (e) {
      throw L.warn('()', { data, type, quick }, e);
    }
  }),
);

// noinspection JSUnusedGlobalSymbols
export default postSalonDataAndRefreshTokens;
